import { render, staticRenderFns } from "./MfSingleCheckbox.vue?vue&type=template&id=322e1ec2&scoped=true&"
import script from "./MfSingleCheckbox.vue?vue&type=script&lang=js&"
export * from "./MfSingleCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MfSingleCheckbox.vue?vue&type=style&index=0&id=322e1ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e1ec2",
  null
  
)

export default component.exports